import alertify from "alertifyjs";

window.alertify = alertify;

alertify.IFRAME_BASED || alertify.dialog('IFRAME_BASED', function () {
    var iframe;
    return {
        set: function () {
            return {}
        },
        // dialog constructor function, this will be called when the user calls alertify.YoutubeDialog(videoId)
        main: function (API_IFRAME_BASED) {
            //set the videoId setting and return current instance for chaining.
            return this.set({
                'API_IFRAME_BASED': API_IFRAME_BASED,
                title: ""
            });
        },
        // we only want to override two options (padding and overflow).
        setup: function () {
            return {
                options: {
                    //disable both padding and overflow control.
                    padding: !1,
                    overflow: !1,
                    resizeTo: true
                }
            };
        },
        // This will be called once the DOM is ready and will never be invoked again.
        // Here we create the iframe to embed the video.
        build: function () {
            // create the iframe element
            iframe = document.createElement('iframe');
            iframe.frameBorder = "no";
            iframe.width = "100%";
            iframe.allowtransparency = "true";
            iframe.height = "100%";
            // add it to the dialog
            this.elements.content.appendChild(iframe);
            this.resizeTo('100%', '100%');
            //give the dialog initial height (half the screen height).
//            this.elements.body.style.minHeight = screen.height * .5 + 'px';
            $('.ajs-maximize').hide();
        },
        // dialog custom settings
        settings: {
            API_IFRAME_BASED: undefined
        },
        // listen and respond to changes in dialog settings.
        settingUpdated: function (key, oldValue, API_IFRAME_BASED) {
            $('.ajs-dialog').css('background', 'none transparent');
            $('.ajs-header').css('background', 'none transparent');
            $('.ajs-footer').css('background', 'none transparent');
            $('.ajs-body').css('background', 'none transparent');
            $('.ajs-close').addClass('close_button_popup');
            $('.ajs-maximize').hide();
            switch (key) {
                case 'API_IFRAME_BASED':
                    iframe.src = API_IFRAME_BASED;
                    break;
            }
        },
        // listen to internal dialog events.
        hooks: {
            // triggered when the dialog is closed, this is seperate from user defined onclose
            onclose: function () {
                iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            },
            // triggered when a dialog option gets update.
            // warning! this will not be triggered for settings updates.
            onupdate: function (option, oldValue, newValue) {
                $('.ajs-maximize').hide();
                switch (option) {
                    case 'resizable':
                        if (newValue) {
                            this.elements.content.removeAttribute('style');
                            iframe && iframe.removeAttribute('style');
                        } else {
                            this.elements.content.style.minHeight = 'inherit';
                            iframe && (iframe.style.minHeight = 'inherit');
                        }
                        break;
                }
            }
        }
    };
});

window.popup = function (url) {
    var string_http_check = url.indexOf('http') !== -1;

    if (!string_http_check) {
        url = location.origin + '/' + url;
    }

    alertify.IFRAME_BASED(url).set({frameless: true}).maximize();
};

window.convertToSlug = function (Text) {
    return Text
        .toLowerCase()
        .replace(/[^\w ]+/g, '')
        .replace(/ +/g, '-')
        ;
};